module.exports = __webpack_public_path__ + "static/media/SPRAY-BG3.b08130cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY-BG3.png
// module id = 280
// module chunks = 0